import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

function renderError(message) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <div style={{ padding: 16, fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Arial' }}>
        <h2 style={{ margin: '0 0 8px 0' }}>Az oldal nem tudott elindulni</h2>
        <div style={{ whiteSpace: 'pre-wrap' }}>{message}</div>
      </div>
    </React.StrictMode>
  );
}

async function loadAzureAdConfig() {
  const apiBase = (process.env.REACT_APP_API_URL || window.location.origin).replace(/\/$/, '');
  const fallback = {
    client_id: process.env.REACT_APP_AZURE_CLIENT_ID,
    tenant_id: process.env.REACT_APP_AZURE_TENANT_ID,
    redirect_uri:
      process.env.REACT_APP_AZURE_REDIRECT_URI || `${window.location.origin.replace(/\/$/, '')}/auth/callback`,
  };

  try {
    const res = await fetch(`${apiBase}/api/auth/config/`);
    if (!res.ok) return fallback;
    const data = await res.json();
    return { ...fallback, ...data };
  } catch {
    return fallback;
  }
}

async function bootstrap() {
  const [{ MsalProvider }, { PublicClientApplication }, { default: App }] = await Promise.all([
    import('@azure/msal-react'), import('@azure/msal-browser'), import('./App'),
  ]);
  const azureConfig = await loadAzureAdConfig();
  const tenantId = azureConfig.tenant_id;
  const clientId = azureConfig.client_id;

  if (!tenantId || !clientId) {
    renderError(
      [
        'Hiányzó Azure AD beállítás.',
        '',
        `tenant_id: ${String(tenantId)}`,
        `client_id: ${String(clientId)}`,
        '',
        'Ellenőrizd:',
        '- backend env: AZURE_AD_TENANT_ID, AZURE_AD_CLIENT_ID (és AUTH_MODE=prod)',
        '- vagy frontend env: REACT_APP_AZURE_TENANT_ID, REACT_APP_AZURE_CLIENT_ID (frontend restart kell)',
      ].join('\n')
    );
    return;
  }

  const msalConfig = {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: azureConfig.redirect_uri,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  };

  const msalInstance = new PublicClientApplication(msalConfig);

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
}

if (process.env.REACT_APP_PUBLIC_OPEN_DAYS === 'true') {
  import('./open-days/PublicOpenDays').then(({ default: PublicOpenDays }) => {
    ReactDOM.createRoot(document.getElementById('root')).render(<PublicOpenDays />);
  }).catch((error) => {
    console.error('Nyílt nap indítási hiba:', error);
    renderError('Nem sikerült betölteni az oldal fájljait. Frissítsd az oldalt Ctrl+F5-tel. Ha a hiba megmarad, jelezd az iskola munkatársainak.');
  });
} else {
  bootstrap().catch((error) => {
    console.error('Alkalmazás indítási hiba:', error);
    renderError('Nem sikerült elindítani az alkalmazást. Frissítsd az oldalt Ctrl+F5-tel.');
  });
}
